module.exports = __webpack_public_path__ + "img/dundee-united.029ca7b1.png";